// VIP 数字级 → 品牌命名档(显示层映射,铁律②VIP=金;品牌:Bronze→Silver→Gold→Inferno)
// 现系统为 VIP0–30,badge 背景分组 0 / 1-5 / 6-10 / 11-15 / 16-20 / 21-25 / 26-30。
// 下方阈值对齐 badge 分组边界(5/15/25),为「合理默认」——业务若有正式档位口径,改这一处即可。
const VIP_TIERS = [
  { name: 'Bronze', max: 5 },
  { name: 'Silver', max: 15 },
  { name: 'Gold', max: 25 },
  { name: 'Inferno', max: Infinity } // 火焰顶级
]

export function vipTierName(level) {
  const n = Number(level)
  const lvl = Number.isFinite(n) ? n : 0
  return (VIP_TIERS.find((t) => lvl <= t.max) || VIP_TIERS[VIP_TIERS.length - 1]).name
}

export function isTopTier(level) {
  return vipTierName(level) === 'Inferno'
}
